<template>
    <app-page>
	    <content-container class="p-1">

			<card title="Groups">

                <toolbar class="p-1">
				    <toolbar-group>
					    <toolbar-button @click="createGroup">
						    <icon src="add" title="Create new group" />
					    </toolbar-button>
				    </toolbar-group>
			    </toolbar>

                <div ref="gridWrapper">
					<kendo-datasource
						ref="gridDataSource"
                        :page-size="gridDataSource.pageSize"
						:schema="gridDataSource.schema"
                        :transport-read="gridDataSource.transport.read"
					/>
					<kendo-grid
						ref="grid"
						:column-resize-handle-width="8"
						:column-menu="false"
						:data-source-ref="'gridDataSource'"
						:filterable="grid.filterable"
						:groupable="grid.groupable"
						:pageable="grid.pageable"
						:reorderable="false"
						:resizable="false"
                        :selectable="true"
						:sortable="true"
                        @change="onGridChange"
					>
						<kendo-grid-column 
							field="reportName" 
							title="Group"
                            :template="reportNameTemplate"
                            :filterable-cell-show-operators="false"
						/>
					</kendo-grid>
				</div>

			</card>

            <create-group-modal
                ref="createGroupModal"
                @create="onGroupCreated"
            />

	    </content-container>
    </app-page>
</template>


<script>
    import _ from 'lodash';
    import kendo from '@progress/kendo-ui/js/kendo.core';
    import { AsyncMixin } from 'pdk/mixins';
    import { notifications } from 'pdk/services';
    import { actions as dashboardActions } from 'dashboard-pdk/store';
    import store, { actions as appActions} from '@/store';
    import { account } from '@/services';
    import { KendoGridMixin } from '@/mixins';
    import { CreateGroupModal } from './modals';


	export default {
        name: 'group-list',
        components: {
            CreateGroupModal
        },
		mixins: [AsyncMixin, KendoGridMixin],
		data() {
			return {
				grid: {
                    groupable: {
                        enabled: false,
                        showFooter: false
                    },
                    filterable: {
                        mode: 'row',
						extra: false
                    },
                    pageable: {
                        alwaysVisible: true,
                        refresh: true
                    }
                },
                gridDataSource: account.getUserGroups_KendoDataSource({
                    role: 2 // Group Admin
                })
			};
        },
		activated() {
			this.$refs.gridDataSource.kendoDataSource.read();
		},
        methods: {
            editGroup(locationGroupID) {
                this.$router.push({
                    name: 'manage-group',
                    params: {
                        locationGroupId: locationGroupID
                    }
                });
            },
            createGroup() {
                this.$refs.createGroupModal.open();
            },
            onGroupCreated(e) {
                this.refresh();

                store.dispatch(dashboardActions.LOCATION_GROUPS_LOAD);
                store.dispatch(appActions.USER_GROUP_ROLES_LOAD);

                notifications.open({
                    content: `Group created`
                });

                this.$router.push({ name: 'manage-group', params: { locationGroupId: e.group.locationGroupID } });
            },
            refresh() {
                this.getKendoGridHelper('grid').refresh();
            },

            reportNameTemplate(item) {
                let text = item.reportName;
                if (item.name !== item.reportName) text += ` (aka ${item.name})`;
                return `<span class='text-link'>${text}</span>`;
            },

            onGridChange(e) {
                const helper = this.getKendoGridHelper(e);
                const item = helper.getSelectedItems()[0];

                this.editGroup(item.locationGroupID);
            }
		}
	};
</script>
